<template>
    <div class="top-grids">
        <div class="video-grid">
            <div class="song song-live">
                <!--<div class="song-info">-->
                    <!--<h3>{{ liveData.title }}</h3>-->
                <!--</div>-->
                <div class="embed-responsive embed-responsive-16by9">
                    <iframe class="embed-responsive-item" :src="liveData.player" allowfullscreen></iframe>
                </div>
                <div class="published">
                    <div class="load_more">
                        <h4>{{ liveData.title }}</h4>
                        <p v-html="liveData.content"></p>
                    </div>
                </div>
            </div>
            <!--分享-->
            <layoutShare :shareUrl="routePath" :videoData="liveData" :videoDownload="''" :embedCode="embedCode" :videoCounter="'0'" :videoCounterView="'false'" :type="'live'"></layoutShare>
            <div class="clearfix"></div>
            <hr>
        </div>
    </div>
</template>

<script>
import layoutShare from '@/components/Share'

export default {
  props: ['liveData', 'routePath', 'embedCode'],
  components: {
    layoutShare
  },
  methods: {
    lineShareJs: function (event) {
      var line = new this.$Line()
      line.share(window.location.href)
    }
  }
}
</script>
